// Mock data for portfolio projects
export const portfolioProjects = [
  {
    id: 1,
    title: "Account Management System (AMS)",
    description: "Comprehensive financial platform for handling account creation, deposits, withdrawals, and transaction tracking. Built with microservices architecture for scalability and reliability.",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=600&fit=crop",
    technologies: ["Flutter", "Microservices", "Spring Boot", "MySQL"],
    category: "Financial Services",
    duration: "2 months"
  },
  {
    id: 2,
    title: "Activity Tracking Platform",
    description: "Intelligent activity tracking app that monitors user activities and generates AI-powered insights for enhanced well-being. Leverages LLM to provide personalized recommendations and health analytics.",
    image: "https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=800&h=600&fit=crop",
    technologies: ["Flutter", "FastAPI", "LLM"],
    category: "Health & Wellness",
    duration: "1 month"
  },
  {
    id: 3,
    title: "Society Management App",
    description: "Comprehensive society management platform that helps register societies and manage their complete operations including member management, maintenance tracking, and community engagement features.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop",
    technologies: ["Flutter", "Firebase", "Cloud Firestore"],
    category: "Management",
    duration: "1 month"
  },
  {
    id: 4,
    title: "Social Media App",
    description: "Feature-rich social networking platform with real-time feeds, messaging, media sharing, and user engagement features. Built with robust backend architecture for scalability.",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=600&fit=crop",
    technologies: ["Flutter", "Spring Boot", "PostgreSQL"],
    category: "Social Networking",
    duration: "2 months"
  },
  {
    id: 5,
    title: "E-mandi: Online Agricultural Marketplace",
    description: "Revolutionary agricultural marketplace eliminating middlemen and ensuring efficient transactions in the agricultural supply chain. Direct farmer-to-buyer platform with real-time pricing.",
    image: "https://images.unsplash.com/photo-1615137705646-cd4c2a4c0ca0?w=800&h=600&fit=crop",
    technologies: ["Flutter", "Spring Boot", "MySQL"],
    category: "Agriculture",
    duration: "1 month"
  }
];

// Mock data for services
export const services = [
  {
    id: 1,
    icon: "Smartphone",
    title: "Flutter Development",
    description: "Create beautiful, natively compiled applications for mobile, web, and desktop from a single codebase with Flutter.",
    features: [
      "Cross-platform mobile apps",
      "Custom UI/UX design",
      "State management (Bloc, Provider, Riverpod)",
      "Native performance optimization"
    ]
  },
  {
    id: 2,
    icon: "Server",
    title: "Backend Development",
    description: "Build robust, scalable backend systems with modern frameworks and best practices for optimal performance.",
    features: [
      "RESTful & GraphQL APIs",
      "Database design & optimization",
      "Authentication & authorization",
      "Cloud deployment (AWS, GCP, Azure)"
    ]
  },
  {
    id: 3,
    icon: "Database",
    title: "Database Architecture",
    description: "Design and implement efficient database solutions tailored to your application's specific needs and scale.",
    features: [
      "SQL & NoSQL databases",
      "Data modeling & migration",
      "Performance tuning",
      "Backup & recovery strategies"
    ]
  },
  {
    id: 4,
    icon: "Zap",
    title: "API Integration",
    description: "Seamlessly integrate third-party services and APIs to extend your application's functionality.",
    features: [
      "Payment gateways",
      "Social media integration",
      "Cloud services",
      "Custom API development"
    ]
  },
  {
    id: 5,
    icon: "Shield",
    title: "Security & Testing",
    description: "Ensure your application is secure, reliable, and performs well under all conditions.",
    features: [
      "Security audits",
      "Unit & integration testing",
      "Load testing",
      "Code quality assurance"
    ]
  }
];

// Mock data for tech stack
export const techStack = {
  frontend: ["Flutter", "Dart", "React", "Vue.js"],
  backend: ["Node.js", "Python", "FastAPI", "Django", "Express.js", "NestJS"],
  databases: ["MongoDB", "PostgreSQL", "MySQL", "Redis", "Firebase"],
  tools: ["Git", "Docker", "AWS", "Postman", "Figma"]
};
